/**
 * Erreur rendue par l'API (ou par le serveur de démonstration, qui imite ses
 * réponses) : le statut HTTP, le message du contrat `{ error }` et, s'il y en
 * a, les `details` rangés par champ.
 */
export interface DetailErreur {
  path: string;
  message: string;
}

export class ApiError extends Error {
  constructor(
    public status: number,
    message: string,
    public details: DetailErreur[] = [],
  ) {
    super(message);
    this.name = 'ApiError';
  }
}
